import Link from 'next/link'
import type { Block, QA } from '@/lib/seoContent'

// 办赛指南 / 项目页的正文渲染:语义化 h2 / ol / table,便于搜索引擎与 AI 解析
export const Blocks = ({ blocks }: { blocks: Block[] }) => (
  <>
    {blocks.map((b) => (
      <section key={b.h2} className="flex flex-col gap-3">
        <h2 className="text-xl font-bold text-gray-900">{b.h2}</h2>
        {b.p?.map((t) => (
          <p key={t} className="leading-relaxed text-gray-700">
            {t}
          </p>
        ))}
        {b.ol && (
          <ol className="flex list-decimal flex-col gap-1.5 pl-6 text-gray-700">
            {b.ol.map((t) => (
              <li key={t}>{t}</li>
            ))}
          </ol>
        )}
        {b.ul && (
          <ul className="flex list-disc flex-col gap-1.5 pl-6 text-gray-700">
            {b.ul.map((t) => (
              <li key={t}>{t}</li>
            ))}
          </ul>
        )}
        {b.table && (
          <div className="overflow-x-auto">
            <table className="w-full border-collapse text-sm">
              <thead>
                <tr>
                  {b.table.head.map((h) => (
                    <th key={h} className="border border-solid border-gray-200 bg-gray-50 px-3 py-2 text-left font-semibold text-gray-800">
                      {h}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {b.table.rows.map((r) => (
                  <tr key={r.join('|')}>
                    {r.map((c, i) => (
                      // eslint-disable-next-line react/no-array-index-key
                      <td key={i} className="border border-solid border-gray-200 px-3 py-2 text-gray-700">
                        {c}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    ))}
  </>
)

export const Faq = ({ faq }: { faq: QA[] }) =>
  faq.length ? (
    <section className="flex flex-col gap-3">
      <h2 className="text-xl font-bold text-gray-900">常见问题</h2>
      {faq.map(({ q, a }) => (
        <details key={q} open className="rounded-xl bg-gray-50 p-4">
          <summary className="cursor-pointer font-semibold text-gray-900">{q}</summary>
          <p className="mt-2 leading-relaxed text-gray-700">{a}</p>
        </details>
      ))}
    </section>
  ) : null

export const RelatedLinks = ({ links, title = '延伸阅读' }: { links: [string, string][]; title?: string }) => (
  <nav aria-label={title} className="flex flex-col gap-3">
    <h2 className="text-base font-semibold text-gray-900">{title}</h2>
    <div className="flex flex-wrap gap-2">
      {links.map(([label, href]) => (
        <Link key={href + label} href={href} className="rounded-full bg-white px-3 py-1 text-sm text-gray-700 ring-1 ring-gray-200 hover:text-[#DB3142]">
          {label}
        </Link>
      ))}
    </div>
  </nav>
)

export const Tldr = ({ text }: { text: string }) => (
  <div className="rounded-xl border-0 border-l-4 border-solid border-[#DB3142] bg-red-50/60 p-4">
    <div className="mb-1 text-xs font-semibold text-[#DB3142]">一句话回答</div>
    <p className="leading-relaxed text-gray-800">{text}</p>
  </div>
)

export const CtaBar = () => (
  <div className="flex flex-col items-start gap-3 rounded-2xl bg-ink p-6 text-white sm:flex-row sm:items-center sm:justify-between">
    <div>
      <div className="text-lg font-bold">用灵缇赛事系统,一键编排你的比赛</div>
      <div className="text-sm text-gray-300">基础功能免费 · 网页与微信小程序通用 · 咨询微信 lingtij</div>
    </div>
    <Link href="/match" className="shrink-0 rounded-full bg-[#DB3142] px-5 py-2 font-semibold text-white">
      免费创建比赛
    </Link>
  </div>
)
